<template>
  <div class="mensageria-scheduled-list">
    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-2"
    >
      <h6 class="text-muted text-uppercase small mb-2 mb-md-0">Agendadas</h6>
      <div class="scheduled-search d-flex align-items-center">
        <input
          class="scheduled-search-input form-control form-control-sm"
          type="search"
          :value="search"
          placeholder="Código, telefone ou e-mail…"
          @input="onSearchInput"
          @keydown.enter.prevent="emitSearch"
        />
        <button
          v-if="search"
          type="button"
          class="btn btn-link btn-sm text-muted px-2"
          title="Limpar busca"
          @click="clearSearch"
        >
          <i class="fas fa-times"></i>
        </button>
        <i v-else class="fas fa-search text-muted px-2"></i>
      </div>
    </div>

    <div v-if="loading" class="text-muted small">
      <i class="fas fa-spinner fa-spin mr-1"></i>
      Carregando agendadas...
    </div>

    <base-alert v-else-if="error" type="warning" class="w-100">
      {{ error }}
    </base-alert>

    <div v-else-if="!items.length" class="text-muted small">
      Nenhuma mensagem agendada (status 2) no período.
    </div>

    <template v-else>
      <div class="table-responsive">
        <table class="table table-sm table-striped mb-0">
          <thead class="thead-light">
            <tr>
              <th>Envio (local)</th>
              <th>Modelo</th>
              <th>Canal</th>
              <th>Destino</th>
              <th>Status</th>
              <th class="text-right">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in items" :key="row.id || row.uuid">
              <td class="text-nowrap">
                {{ formatSendDate(row.send_date || row.sendDate) }}
              </td>
              <td>
                <code class="small">{{
                  row.model_name || row.modelName || '—'
                }}</code>
              </td>
              <td>{{ row.channel || '—' }}</td>
              <td class="small text-muted">{{ row.to || '—' }}</td>
              <td>{{ row.status_label || row.statusLabel || row.status }}</td>
              <td class="text-right text-nowrap">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  :disabled="sendingId === row.id || sendingId === row.uuid"
                  title="Antecipar send_date para agora"
                  @click="onSendNow(row)"
                >
                  <i
                    v-if="sendingId === row.id || sendingId === row.uuid"
                    class="fas fa-spinner fa-spin mr-1"
                  ></i>
                  Disparar agora
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mt-2"
      >
        <p class="text-muted small mb-2 mb-md-0">
          {{ perPage }} por página, listando {{ rangeFrom }} a {{ rangeTo }}
          de
          <span v-if="search">{{ total }} item(s) filtrados(s)</span>
          <span v-else>{{ total }} item(s)</span>
        </p>
        <b-pagination
          v-if="totalPages > 1"
          :value="page"
          :total-rows="total"
          :per-page="perPage"
          size="sm"
          align="right"
          class="mb-0"
          @change="onPageChange"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { formatServerUtcToLocal } from './utils/datetime'

export default {
  name: 'MensageriaScheduledList',
  props: {
    loading: { type: Boolean, default: false },
    error: { type: String, default: '' },
    items: { type: Array, default: () => [] },
    total: { type: Number, default: 0 },
    page: { type: Number, default: 1 },
    perPage: { type: Number, default: 10 },
    search: { type: String, default: '' },
  },
  data() {
    return {
      searchDebounce: null,
      sendingId: null,
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil((Number(this.total) || 0) / this.perPage))
    },
    rangeFrom() {
      if (!this.total) return 0
      return (this.page - 1) * this.perPage + 1
    },
    rangeTo() {
      return Math.min(this.page * this.perPage, this.total)
    },
  },
  beforeDestroy() {
    if (this.searchDebounce) clearTimeout(this.searchDebounce)
  },
  methods: {
    formatSendDate(value) {
      return formatServerUtcToLocal(value, 'DD/MM/YYYY HH:mm')
    },
    onSearchInput(event) {
      const value = event && event.target ? event.target.value : ''
      if (this.searchDebounce) clearTimeout(this.searchDebounce)
      this.searchDebounce = setTimeout(() => {
        this.$emit('search', value)
      }, 350)
    },
    emitSearch() {
      if (this.searchDebounce) clearTimeout(this.searchDebounce)
      this.$emit('search', this.search)
    },
    clearSearch() {
      if (this.searchDebounce) clearTimeout(this.searchDebounce)
      this.$emit('search', '')
    },
    onPageChange(page) {
      this.$emit('page-change', page)
    },
    onSendNow(row) {
      if (!row || row.id == null) return
      this.sendingId = row.id
      this.$emit('send-now', row, () => {
        this.sendingId = null
      })
    },
  },
}
</script>

<style scoped>
.scheduled-search {
  max-width: 16rem;
  width: 100%;
  padding: 0.25rem 0.4rem;
  border: 0.5px solid #dadada;
  border-radius: 5px;
  background: #fff;
}

.scheduled-search-input {
  border: none;
  box-shadow: none;
  background: transparent;
  padding: 0.15rem 0.25rem;
}

.scheduled-search-input:focus {
  box-shadow: none;
}
</style>
